module.exports = __webpack_public_path__ + "static/media/742ce529-db2e-4652-a763-57d4dd025b60.1dac7f46.jpeg";